import { httpClient, HttpPGAdapter } from "@sia/style-guide";
import KeycloakIDPAdapter from "../IDPAdapter/KeycloakIDPAdapter";
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const create = () => {
  return new HttpPGAdapter(httpClient, apiBaseUrl, KeycloakIDPAdapter);
};

const pgAdapter = create();
export default pgAdapter;
